import { useMutation, useQueryClient } from '@tanstack/react-query';
import { message } from 'antd';
import type { AxiosError } from 'axios';

import { NOTIFICATION_MESSAGES } from '@/shared/lib/constants';
import { connectorKeys } from '@/shared/lib/query/queryKeys';

import { createConnectorApi } from '@/entities/connector';
import type { ConnectorApiError, CreateConnectorRequest } from '@/entities/connector';

export const useCreateConnector = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (request: CreateConnectorRequest) => createConnectorApi(request),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: connectorKeys.list() });

      message.success(NOTIFICATION_MESSAGES.CONNECTOR_CREATE_SUCCESS_DESC);
    },
    onError: (error: AxiosError<ConnectorApiError>) => {
      const errorCode = error.response?.data?.error_code;

      if (errorCode === 'connector_name_conflict') {
        message.error(NOTIFICATION_MESSAGES.CONNECTOR_NAME_CONFLICT_DESC);
        return;
      }

      message.error(NOTIFICATION_MESSAGES.CONNECTOR_FORM_ERROR);
    },
  });
};
